import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { getMyRole, roles } from '../../utils/handler';
import { LoadingPage } from '../components/CommonPages';
import ManagementDashboard from './MenuItems/index';
import RegistrarDashboard from './registrarDashboard';
import UserDashboard from './userDashboard';

const Dashboard: React.FC = (props: any): JSX.Element => {
  return (
    <>
      <Helmet>
        <title>User Dashboard - Saw.com Domain Name Brokerage</title>
      </Helmet>

      {!getMyRole() ? <LoadingPage /> : getMyRole().includes(roles.registrar) ? <RegistrarDashboard /> : getMyRole().includes(roles.buyer) ? <UserDashboard /> : getMyRole().includes(roles.admin) || getMyRole().includes(roles.consultant) ? <ManagementDashboard /> : <LoadingPage />}
    </>
  );
};
const mapStateToProps = (state: any) => ({
  myProfile: state.userReducer.myProfile,
});

export default connect(mapStateToProps, {})(Dashboard);
